import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/logo.svg'


const _withScopeId = n => (_pushScopeId("data-v-0c361de8"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "footer-contacts" }, [
  /*#__PURE__*/_createElementVNode("a", {
    class: "footer-contacts-company",
    href: "tel:+79827500000"
  }, "+79827500000"),
  /*#__PURE__*/_createElementVNode("p", { class: "footer-contacts-company" }, "ООО \"ОРКА ДЕВ\"")
], -1))

import { inject, reactive } from 'vue'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const data = reactive({
  isTablet: inject('isTablet')
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["footer", {tablet: _unref(data).isTablet}])
  }, [
    _createElementVNode("img", {
      class: _normalizeClass(["footer-image", {tablet: _unref(data).isTablet}]),
      src: _imports_0,
      alt: ""
    }, null, 2),
    _hoisted_1
  ], 2))
}
}

})